module.exports =
  '_COMMON_FOOTER':
    'TERM_OF_SERVICE': '利用規約'
    'PRIVACY_POLICY': '個人情報保護ポリシー'
    'LEGAL': '特定商取引法に基づく表示'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/common-footer/i18n/ja.coffee